import styled from '@xstyled/styled-components'

export const MoteCardMediumActionsContainer = styled.divBox({
  display: 'grid',
  gap: '2',
  width: 'full'
})
